module.exports = __webpack_public_path__ + "img/体系落地.ed577bf4.svg";